(() => {
  const date = new Intl.DateTimeFormat('fr-FR', {day:'numeric', month:'long', year:'numeric'});
  const number = new Intl.NumberFormat('fr-FR', {maximumFractionDigits:1});
  function demoReviews(product) {
    const starts = [
      'Très joli rendu une fois porté, il capte bien la lumière sans être trop voyant.',
      'Je voulais quelque chose de facile à porter tous les jours et le résultat me plaît beaucoup.',
      'Belle surprise à l’ouverture, les détails sont encore plus délicats qu’en photo.',
      'Acheté pour compléter une tenue assez simple, il apporte juste ce qu’il faut d’éclat.',
      'Je l’ai porté dès sa réception et j’ai déjà reçu plusieurs compliments.',
      'La finition est soignée et le bijou paraît vraiment élégant au poignet, au cou ou à la main.',
      'Je cherchais un modèle discret mais pas banal, celui-ci correspond exactement à ce que je voulais.',
      'Le style est fin et féminin, sans donner l’impression d’en faire trop.',
      'Commandé pour un cadeau, il a beaucoup plu et la présentation faisait son petit effet.',
      'Il se marie facilement avec les bijoux que je porte déjà, aussi bien dorés qu’avec des tons neutres.',
      'J’hésitais à commander sans l’avoir essayé, mais les proportions sont très harmonieuses.',
      'Simple, lumineux et agréable à porter : exactement le type de bijou que j’aime.',
      'Le motif est original tout en restant assez sobre pour être porté souvent.',
      'Je le trouve encore plus joli en vrai, surtout lorsque la lumière accroche les petits détails.',
      'Une pièce délicate qui habille immédiatement une chemise blanche ou une robe noire.',
      'Je voulais me faire plaisir sans choisir un modèle trop imposant et je ne regrette pas.',
      'Le bijou est léger et je l’oublie facilement une fois porté.',
      'La couleur est douce et élégante, elle ne fait pas trop jaune à la lumière du jour.',
      'Reçu rapidement et bien protégé, il était impeccable en sortant de l’écrin.',
      'Je l’ai choisi pour une occasion, mais il est assez facile à assortir pour le quotidien.',
      'Les lignes sont fines et le rendu est vraiment propre, même vu de près.',
      'J’aime beaucoup son côté minimaliste avec le petit détail qui attire le regard.',
      'Il donne une touche plus habillée sans alourdir la tenue.',
      'C’était ma première commande et je suis contente du rendu comme de la présentation.',
      'La taille me convient bien et le bijou reste confortable pendant toute la journée.',
      'Je cherchais depuis un moment un modèle dans ce style, celui-ci est à la fois moderne et facile à porter.',
      'Le rendu est un peu plus fin que je ne l’imaginais, mais finalement c’est ce qui fait son charme.',
      'J’ai apprécié les détails et la façon dont le bijou tombe une fois porté.',
      'Une jolie découverte, il fait élégant sans paraître fragile.',
      'Je le porte très souvent depuis que je l’ai reçu et il accompagne facilement toutes mes tenues.'
    ];
    const ends = [
      'Je pense le porter très souvent.',
      'Il fonctionne aussi bien seul qu’associé à une pièce plus fine.',
      'Le rapport entre le style et le prix me semble vraiment intéressant.',
      'Je le choisirais sans hésiter pour faire un cadeau.',
      'L’écrin est soigné et permet de l’offrir directement.',
      'Pour un rendu discret et raffiné, c’est un très bon choix.',
      'Il apporte tout de suite une touche plus travaillée à la tenue.',
      'Je suis contente d’avoir choisi ce modèle plutôt qu’un bijou plus classique.',
      'Les photos donnent une bonne idée du rendu et les dimensions me conviennent.',
      'J’aurais simplement aimé qu’il soit légèrement plus grand, mais il reste très élégant.',
      'Après plusieurs journées porté, il reste confortable et ne me gêne pas.',
      'Il a rejoint mes bijoux favoris pour les sorties comme pour le travail.',
      'La personne à qui je l’ai offert l’a mis immédiatement.',
      'Je l’associe facilement à une montre ou à d’autres bijoux fins.',
      'C’est le petit détail qui finit bien une tenue sans la surcharger.',
      'Je recommande surtout ce modèle à celles qui aiment les bijoux fins.',
      'La finition correspond bien à ce que j’attendais en commandant.',
      'Je garde la boutique en tête pour un prochain cadeau.',
      'Il fait son effet tout en restant suffisamment sobre pour la journée.',
      'Une belle idée si l’on cherche un cadeau élégant à prix raisonnable.',
      'Je l’aime particulièrement porté seul, le dessin ressort mieux ainsi.',
      'La forme change des modèles que l’on voit partout.',
      'Je suis satisfaite de mon choix et je le commanderais à nouveau.',
      'Il est rapidement devenu l’un des bijoux que je porte le plus.'
    ];
    const names = ['Camille', 'Léa', 'Manon', 'Sarah', 'Inès', 'Julie', 'Clara', 'Louise', 'Emma', 'Alice', 'Chloé', 'Pauline', 'Élise', 'Marion', 'Jade', 'Anaïs', 'Lucie', 'Sophie', 'Laura', 'Céline', 'Amélie', 'Nina', 'Mathilde', 'Émilie', 'Charlotte', 'Zoé', 'Amandine', 'Marine'];
    const seed = Number(product.id) % 51;
    const photos = (Array.isArray(product.photos) ? product.photos : []).map(p => p.startsWith('//') ? `https:${p}` : p);
    return Array.from({length:70 + seed}, (_, i) => ({
      author:`${names[(i + seed) % names.length]} ${String.fromCharCode(65 + (i * 7 + seed) % 26)}.`,
      rating:i % 19 === 0 ? 3 : i % 5 === 0 ? 4 : 5,
      body:`${starts[(i * 7 + seed) % starts.length]} ${ends[(i * 11 + Math.floor(seed / 7)) % ends.length]}`,
      date:new Date(Date.UTC(2026,8,13) - i * 86400000).toISOString(),
      photo:i % 3 === 0 ? (photos[Math.floor(i / 3)] || '') : '', demo:true
    }));
  }
  const element = (tag, text, className) => {
    const node = document.createElement(tag);
    if (text !== undefined) node.textContent = text;
    if (className) node.className = className;
    return node;
  };
  function init() {
    document.querySelectorAll('[data-or-review-section]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      let data;
      try { data = JSON.parse(section.querySelector('[data-orceliane-reviews]').textContent); } catch { data = []; }
      if ((!Array.isArray(data) || data.length === 0) && section.querySelector('[data-or-review-demo]')) {
        try { data = demoReviews(JSON.parse(section.querySelector('[data-or-review-demo]').textContent)); } catch { data = []; }
      }
      const reviews = (Array.isArray(data) ? data : []).filter(r => r && typeof r.body === 'string' && r.body.trim() && typeof r.author === 'string' && r.author.trim() && Number.isInteger(r.rating) && r.rating >= 1 && r.rating <= 5).map(r => {
        let photo = '';
        try { const url = new URL(r.photo); if(url.protocol === 'https:') photo = url.href; } catch {}
        return {...r, photo, timestamp: Date.parse(r.date) || 0};
      });
      const count = reviews.length;
      const ratings = document.querySelectorAll('[data-or-review-rating]');
      ratings.forEach(a => { a.hidden = !count; });
      if (!count) return;
      const demonstration = reviews.some(r => r.demo === true);
      section.querySelector('[data-review-demo-notice]').hidden = !demonstration;
      const average = reviews.reduce((sum,r) => sum + r.rating, 0) / count;
      const summary = `${number.format(average)}/5 · ${count} avis${demonstration ? ' fictifs — Démonstration' : ''}`;
      ratings.forEach(a => { a.textContent = `★ ${summary}`; a.setAttribute('aria-label', `${summary} — Lire les avis clients`); });
      section.querySelector('[data-review-empty]').hidden = true;
      section.querySelector('[data-review-tools]').hidden = false;
      const summaryNode = section.querySelector('[data-review-summary]');
      summaryNode.textContent = summary; summaryNode.hidden = false;
      const grid = section.querySelector('[data-review-grid]');
      const more = section.querySelector('[data-review-more]');
      const pagination = section.querySelector('[data-review-pagination]');
      let sorted = [], visible = 0;
      function showMore() {
        const fragment = document.createDocumentFragment();
        sorted.slice(visible, visible + 12).forEach(review => {
          const card = element('article', undefined, 'or-review');
          if(review.photo) {
            const img = element('img'); img.src = review.photo; img.alt = review.demo ? 'Image générée par IA — Démonstration' : 'Photo partagée avec cet avis client'; img.loading = 'lazy'; img.width = 480; img.height = 480; img.referrerPolicy = 'no-referrer'; card.append(img);
            if(review.demo) card.append(element('p', 'Image générée par IA — Démonstration', 'or-review__image-label'));
          }
          const body = element('div', undefined, 'or-review__body');
          const stars = element('div', '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating), 'or-review__stars'); stars.setAttribute('aria-label', `${review.rating} sur 5`); stars.setAttribute('role', 'img');
          body.append(stars, element('p', review.author, 'or-review__author'));
          if(review.demo) body.append(element('p', 'Avis fictif — Démonstration', 'or-demo-label'));
          if(review.timestamp) { const time = element('time', date.format(review.timestamp)); time.dateTime = new Date(review.timestamp).toISOString(); body.append(time); }
          body.append(element('p', review.body)); card.append(body); fragment.append(card);
        });
        grid.append(fragment); visible = Math.min(visible + 12, count); pagination.hidden = visible >= count;
        section.querySelector('[data-review-status]').textContent = `${visible} avis affichés sur ${count}`;
      }
      function sort(value) {
        sorted = [...reviews].sort((a,b) => {
          if(value === 'photos') return Number(Boolean(b.photo)) - Number(Boolean(a.photo)) || b.timestamp - a.timestamp;
          if(value === 'high') return b.rating - a.rating || b.timestamp - a.timestamp;
          if(value === 'low') return a.rating - b.rating || b.timestamp - a.timestamp;
          return b.timestamp - a.timestamp;
        });
        grid.replaceChildren(); visible = 0; showMore();
      }
      section.querySelector('[data-review-sort]').addEventListener('change', event => sort(event.target.value));
      more.addEventListener('click', () => { const start = grid.children.length; showMore(); const next = grid.children[start]; if(next) {next.tabIndex = -1; next.focus({preventScroll:true});} });
      sort('photos');
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
